import React, { useEffect, useMemo, useState } from "react";

import { Paper } from "@mui/material";
import { getExternalDataAccurancyLevel } from "root/entities/Custom/ExternalDataAccurancy";
import { getServerDate } from "root/utils/date";

import RightDrawer from "root/components/RightDrawer";

import useDateRange from "root/hooks/useDateRange";
import useQueryAPI from "root/hooks/useQueryAPI";

import ProductDrawerContent from "./ProductDrawerContent";

// ------------------------------------------------------------------------------------------------
const ProductDrawer = ({ isOpen, onClose = () => {}, productId, dateRange: parentDateRange }) => {
  const { dateRange: defaultDateRange } = useDateRange(30);
  const [dateRange, setDateRange] = useState(
    parentDateRange ? parentDateRange.map(item => new Date(item)) : defaultDateRange
  );
  //
  const [showSimilarData, setShowSimilarData] = useState(false);
  //
  const productParams = {
    product_ids: productId,
    product_ads_min: 500,
    date_from: getServerDate(dateRange[0]),
    date_to: getServerDate(dateRange[1]),
    extra_fields: [
      ...[
        "ea_ads",
        "product_ads",
        "proceeds",
        "orders",
        "price",
        "quantity",
        "reviews_diff",
        "ro_proceeds",
        "ro_orders",
      ].map(i => i + "," + i + "_dynamic"),
      "seller",
    ].join(),
  };
  const { data: productRes = { results: [{ dynamic: [] }] }, isLoading: isLoadingProduct } =
    useQueryAPI({
      apiFuncName: "getWBDynamicProducts",
      params: productParams,
    });
  const rawProductData = useMemo(() => (productRes.results || [])[0] || {}, [productRes]);
  const onlyProductCard = useMemo(
    () => Number(rawProductData?.proceeds) > Number(rawProductData?.ro_proceeds),
    [rawProductData?.proceeds, rawProductData?.ro_proceeds]
  );
  const productData = useMemo(() => {
    const data = rawProductData;
    if (!showSimilarData) return data;
    return {
      ...data,
      proceeds: data.ro_proceeds,
      orders: data.ro_orders,
      dynamic: (data.dynamic || []).map(dynItem => ({
        ...dynItem,
        proceeds: dynItem.ro_proceeds,
        orders: dynItem.ro_orders,
      })),
    };
  }, [rawProductData, showSimilarData]);
  const productDynamic = useMemo(() => productData.dynamic || [], [productData]);
  //
  const socialNetworksDynamic = useMemo(
    () =>
      productDynamic
        .filter(item => item.ea_ads)
        .map(item => {
          const value = {};
          for (const key in item.ea_ads) {
            value[key] = item.ea_ads[key].count;
          }
          return { date: item.date, value };
        }),
    [productDynamic]
  );
  // ------------- ЛОГИКА ПРОВЕРКИ НАДЁЖНОСТИ ДАННЫХ ПО ПОСТАВЩИКУ
  const sellerId = useMemo(
    () => rawProductData?.seller?.id || rawProductData?.seller,
    [rawProductData]
  );
  //
  const sellerDateRange = useMemo(
    () =>
      dateRange[1] > new Date("2026-04-01")
        ? [new Date("2026-03-01"), new Date("2026-03-31")]
        : dateRange,
    [dateRange]
  );
  //
  const { data: sellerRes = {}, isLoading: isLoadingSeller } = useQueryAPI({
    apiFuncName: "getWBDynamicSellers",
    params: {
      seller_ids: sellerId,
      date_from: getServerDate(sellerDateRange[0]),
      date_to: getServerDate(sellerDateRange[1]),
      extra_fields: "seller_sales,orders,diff_sales,weighted_price,percent_sales",
      limit: 100,
    },
    options: { skip: !sellerId },
  });
  //
  const sellerData = useMemo(() => (sellerRes.results || [])[0] || {}, [sellerRes]);
  //
  // Если отзывов больше чем выкупов то мы считаем эти данные некорректными, иначе смотрим по продавцу
  const ordersLessThenReviews = useMemo(
    () =>
      productData.orders &&
      productData.ro_reviews_diff &&
      productData.orders < productData.ro_reviews_diff,
    [productData]
  );
  // ------------- ТУТ МЫ ПОНИМАЕМ СТОИТ ЛИ ЗАМЕНЯТЬ ДАННЫЕ В СЛУЧАЕ ЕСЛИ ОНИ НЕ ТОЧНЫ
  const dataCorrectLevel = useMemo(
    () => getExternalDataAccurancyLevel({ ...sellerData, onlyProductCard, ordersLessThenReviews }),
    [onlyProductCard, sellerData, ordersLessThenReviews]
  );
  const isLoading = useMemo(
    () => isLoadingProduct || isLoadingSeller,
    [isLoadingProduct, isLoadingSeller]
  );
  //
  useEffect(() => {
    if (isLoading) {
      setShowSimilarData(false);
      return;
    }
    const isCorrect = dataCorrectLevel.isCorrect;
    setShowSimilarData(!isCorrect);
    // setDisableCerebro(!!isCorrect);
  }, [dataCorrectLevel]);
  //
  //
  return (
    <RightDrawer {...{ isOpen, onClose }} zIndex={10001}>
      <Paper>
        <ProductDrawerContent
          data={productData}
          isLoading={isLoading}
          productId={productId}
          params={productParams}
          socialNetworks={socialNetworksDynamic}
          // maxDate={maxDate}
          dateRange={dateRange}
          setDateRange={setDateRange}
          //
          {...{ showSimilarData, setShowSimilarData, dataCorrectLevel }}
        />
      </Paper>
    </RightDrawer>
  );
};

export default ProductDrawer;
